import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Barcode from 'react-barcode'
import QRCode from 'qrcode.react'

function TicketHeader(props) {
    let header = `Билет #${props.number + 1}.`
    if (props.ticket.sector) {
        header = `${header} ${props.ticket.sector}.`
    }

    if (props.ticket.row && props.ticket.seat) {
        return (
            <>
                {header}
                <br/>
                {props.ticket.sector}, Ряд {props.ticket.row}, Место {props.ticket.seat}.
            </>
        )
    }
    return <>{header}</>
}

class TicketList extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.tickets.map((ticket, number) => {
                    return (
                        <div className='tickets-ticket-block' key={ticket.ticket_id}>

                            <div className="tickets-popup-subtitle">
                                <TicketHeader ticket={ticket} number={number}/>
                            </div>

                            <div className="tickets-graphic-codes-block">

                                <div className="barcode">
                                    {ticket.clicking_qrcode_token && 
                                        <QRCode value={ticket.clicking_qrcode_token} />
                                    }
                                </div>

                                <div className="qrcode">
                                    {ticket.clicking_barcode_token && 
                                        <Barcode value={ticket.clicking_barcode_token} 
                                            format="EAN13"
                                            height="79"
                                            width="2"/>
                                    }
                                </div>

                            </div>
                        </div>
                    );
                })}
            </React.Fragment>
        );
    }
}

TicketList.propTypes = {
    tickets: PropTypes.array.isRequired,
    mode: PropTypes.string
}

export default TicketList;
